// removed by extract-text-webpack-plugin
module.exports = {"windRoseChart":"windRoseChart__2YDlG","emptyDataDisplay":"emptyDataDisplay__2l2q5","labeWrapper":"labeWrapper__I2Tko","tooltip":"tooltip__11phy","text":"text__1v6WK","textDescription":"textDescription__1ZsXt","actualDescriptionWrapper":"actualDescriptionWrapper__1PxUQ","actual":"actual__2oUTy","target":"target__S8l1B","closeIconWrapper":"closeIconWrapper__1ARLe","closeIcon":"closeIcon__3jyZT","svgIe":"svgIe__qfvTU"};


//////////////////
// WEBPACK FOOTER
// ./components/windRoseChart/style.scss
// module id = cMmm
// module chunks = 0